// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__wX8GP","vLegacy":"SelectSecondary_vLegacy__BO7MY","error":"SelectSecondary_error__3Bmhj","disabled":"SelectSecondary_disabled__JumHV"};